import { carouselData } from '@/mocks/home-data';

const carouselImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=An%20artistic%20composition%20of%20floating%20newspaper%20headlines%20and%20breaking%20news%20graphics%20in%20warm%20red%20and%20gold%20tones%2C%20abstract%20journalistic%20collage%20style%2C%20editorial%20design%20aesthetic%2C%20dramatic%20lighting%2C%20high%20detail%20contemporary%20art%20photography&width=1400&height=600&seq=carousel-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=A%20dramatic%20close-up%20of%20a%20smartphone%20screen%20displaying%20glowing%20social%20media%20metrics%20with%20shadowy%20hands%20manipulating%20data%20behind%20it%2C%20dark%20background%20with%20warm%20amber%20warning%20highlights%2C%20investigative%20tech-noir%20aesthetic%2C%20editorial%20photography&width=1400&height=600&seq=carousel-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=A%20vintage%20radio%20studio%20microphone%20with%20a%20cracked%20housing%20standing%20alone%20in%20spotlight%2C%20crumbling%20pedestal%20beneath%20it%2C%20dramatic%20theatrical%20lighting%20with%20warm%20gold%20and%20deep%20shadow%2C%20symbolic%20composition%2C%20cinematic%20editorial%20photography&width=1400&height=600&seq=carousel-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20reading%20glasses%20resting%20on%20an%20open%20notebook%20with%20a%20red%20pen%2C%20beside%20a%20steaming%20cup%20of%20tea%2C%20warm%20cozy%20reading%20nook%20atmosphere%2C%20soft%20natural%20window%20light%2C%20intellectual%20lifestyle%20photography%2C%20editorial%20quality%20with%20warm%20amber%20tones&width=1400&height=600&seq=carousel-04&orientation=landscape',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">焦点专题</h2>
          <p className="text-sm text-foreground-600">深度报道 · 全景梳理 · 独家视角</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group flex flex-col"
            >
              <div className="w-full h-52 md:h-60 overflow-hidden">
                <img
                  src={carouselImages[item.id]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 inline-block w-fit mb-3 whitespace-nowrap">
                  {item.label}
                </span>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}